export const DEFAULT_DAILY_REQUEST_LIMIT = 366;
export const DEFAULT_HOURLY_REQUEST_LIMIT = 7 * 24;
export const DEFAULT_MINUTELY_REQUEST_LIMIT = 2 * 60;
